'use client'

import {
  Col,
  LoadMoreSection,
  Skeleton,
  Typography,
  Row,
  Icon,
} from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import { useAgentListMyProjects } from '@repo/services'
import { PropertiesProjectsEmptyState } from './projects.properties.empty-state'
import { PropertyCard } from '../dashboard'
import { ButtonLink } from '@repo/shared/components'

export const ProjectsMyProperties = () => {
  const { t } = useTranslate()

  const { data, fetchNextPage, isLoading, hasNextPage, isFetchingNextPage } =
    useAgentListMyProjects({
      skip: 0,
      limit: 5,
    })

  const projects =
    data?.pages.flatMap((page) => page.data?.projects || []) || []
  const posts = data?.pages.flatMap((page) => page.data?.posts || []) || []

  const projectItems = projects.map((project) => ({
    post: posts.find((post) => post.projectID === project.id),
    project: project,
    agent: undefined,
  }))

  return (
    <Col className='gap-xs w-full rounded-sm md:p-md'>
      <Row className='gap-md items-center justify-between p-md md:p-0'>
        <Typography
          variant='h3'
          size='2xl'
          weight='bold'
          color='text-neutral-main'
        >
          {t('dashboardAgent_my_properties')}
        </Typography>
        <ButtonLink
          variant='fill'
          size='sm'
          color='base'
          href='/projects/add'
          disabled={isLoading}
          startIcon={<Icon name='PlusLine' className='size-2' />}
        >
          {t('dashboardAgent_new_property_action')}
        </ButtonLink>
      </Row>

      <Col className='flex-1 gap-md'>
        {projectItems.map((projectItem, index) => (
          <PropertyCard
            key={index}
            property={projectItem.project}
            post={projectItem.post}
            className='md:border  md:border-neutral-surface-dark rounded-sm'
            layout='projects'
          />
        ))}

        {isLoading && (
          <Col className='gap-md px-md'>
            {Array.from({ length: 10 }).map((_, index) => (
              <Skeleton
                key={index}
                className='w-full h-20  bg-neutral-surface-light rounded-md '
              />
            ))}
          </Col>
        )}

        {projects.length === 0 && (
          <PropertiesProjectsEmptyState isLoading={isLoading} />
        )}
      </Col>

      <LoadMoreSection
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
      />
    </Col>
  )
}
